import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, IconButton, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '~/services/service.base';
import { MediaSearchService } from '~/services/service.media.search';
import { RecentService } from '~/services/service.recent';
import { UIService } from '~/services/service.ui';
import { Column } from '~/views/atoms/boxes';
import { Icons } from '~/views/atoms/icons';
import { ImagesList } from '~/views/molecules/list-image/list.image';
import { Breadcrumb } from '~/views/molecules/nav.breadcrumbs';
import { PageHeader } from '~/views/molecules/page.header';
import { TabsFilter } from '~/views/molecules/tabs.filter';
import { PageWrapper } from '~/views/organisms/wrapper.page';
import { EFilterType } from '~/shared/types/filter';
import { useSearchForm } from '~/shared/hooks/useSearchForm';
import { EBreadcrumbKey } from '~/shared/types';
import { MediaSwiper } from '~/views/organisms/media-swiper/media.swiper';
import { ServiceMediaViewer } from '~/services/service.media.viewer';
import { useFileDownload, useFileInfo } from '~/shared/hooks';
import { AuthService } from '~/services/service.auth';
import { runInAction } from 'mobx';
export const PageFundsRecent = observer(() => {
    const { t } = useTranslation();
    const { breadcrumbsSvc } = useService(UIService);
    const { openDialogSvc } = useService(MediaSearchService);
    const recentSrv = useService(RecentService);
    const serviceMediaViewer = useService(ServiceMediaViewer);
    const authService = useService(AuthService);
    const clickImageHandler = useCallback((item) => {
        serviceMediaViewer.setOpenedItem(item);
        serviceMediaViewer.setOpenedItemIndex(serviceMediaViewer.filterMediaItems(recentSrv.items || []));
        serviceMediaViewer.mediaViewOpenService.handleOpen();
    }, [recentSrv.items, serviceMediaViewer]);
    const closeImageHandler = useCallback(() => {
        serviceMediaViewer.mediaViewOpenService.handleClose();
    }, [serviceMediaViewer.mediaViewOpenService]);
    const { fileInfoHandler, fileInfoContent } = useFileInfo();
    const { downloadFromServer } = useFileDownload();
    useEffect(() => {
        breadcrumbsSvc.use([
            {
                key: EBreadcrumbKey.recent,
            },
        ]);
    }, [breadcrumbsSvc]);
    useEffect(() => {
        recentSrv.getRecentItems();
    }, [recentSrv]);
    recentSrv.filterSvc.use([
        { value: EFilterType.all, label: t('RECENT_TABFILTER_ALL') },
        { value: EFilterType.image, label: t('RECENT_TABFILTER_PHOTOS') },
        { value: EFilterType.video, label: t('RECENT_TABFILTER_VIDEOS') },
    ]);
    const searchForm = useSearchForm();
    return (_jsxs(PageWrapper, { children: [_jsx(Breadcrumb.Nav, { children: breadcrumbsSvc.children }), _jsxs(PageHeader, { justifyContent: "flex-start", children: [_jsx(Grid, { container: true, flexDirection: "column", children: _jsx(Typography, { variant: "h2", children: t('RECENT_PAGE_TITLE') }) }), _jsx(Grid, { container: true, flexDirection: "column", children: _jsx(Grid, { container: true, justifyContent: "flex-end", children: _jsx(IconButton, { color: "inherit", onClick: openDialogSvc.handleOpen, children: _jsx(Icons.Search, {}) }) }) })] }), _jsxs(Column, { px: 2, py: 1.5, gap: 2, children: [_jsx(TabsFilter, { items: recentSrv.filterSvc.tabs, value: recentSrv.filterSvc.tab, onChange: (value) => {
                            runInAction(() => {
                                recentSrv.setFilterType(value);
                                recentSrv.getRecentItems();
                                recentSrv.filterSvc.handleChange(value);
                            });
                        } }), _jsx(ImagesList, { offset: recentSrv.lastItemId, itemData: recentSrv.items, clickImageHandler: clickImageHandler })] }), searchForm, serviceMediaViewer.mediaViewOpenService.open && serviceMediaViewer.openedItem && (_jsx(MediaSwiper, { closeButtonHandler: closeImageHandler, items: serviceMediaViewer.filterMediaItems(recentSrv.items || []), initialSlideIndex: serviceMediaViewer.openedItemIndex, downloadButtonHandler: authService.isLogged ? downloadFromServer : undefined, infoButtonHandler: fileInfoHandler })), fileInfoContent] }));
});
